import { Components, TokensProps } from "@thisgorilla/primate-ds";
import styled, { useTheme } from "styled-components";
import { PollContentProps } from "./PollContent";

export const PollOption = ({
  title,
  onClick,
  isVoted,
  percentage,
  isPollActive,
  isWithinRepostModal,
}: PollContentProps.PollOption) => {
  const { typography, Color } = useTheme();
  const showVotePercentage = !isWithinRepostModal && (isVoted || !isPollActive);

  return (
    <Container
      onClick={onClick}
      $showGradientBackground={showVotePercentage && !isWithinRepostModal}
      $isInInteractive={!showVotePercentage && !isWithinRepostModal}
      $percentage={percentage}
    >
      <Components.Text
        text={title}
        style={{ tokenStyle: typography.Body.L }}
        color={
          showVotePercentage ? Color.text["text-on-bold"].value : undefined
        }
        renderInSingleLine={true}
        maxLineLength={1}
      />
      {showVotePercentage && (
        <Components.Counter
          color={percentage < 80 ? "Primary-Bold" : "Primary"}
          count={`${percentage}%`}
          kind="Fill"
          size="Large"
        />
      )}
    </Container>
  );
};

const getGradientBackground = (
  theme: TokensProps.ThemeProps,
  percentage: number
) => {
  return `linear-gradient(to right, ${
    theme.Color.icon.brand.bold.default.value
  } ${percentage}%, ${theme.Color.background.brand.default.value} ${
    percentage + 20
  }%, ${theme.Color.background.brand.default.value} 95.85%)`;
};

const Container = styled.div<{
  $showGradientBackground: boolean;
  $percentage: number;
  $isInInteractive: boolean;
}>(({ theme, $percentage, $showGradientBackground, $isInInteractive }) => {
  return `
    display:flex;
    justify-content:space-between;
    border-radius: ${theme.radius["radius-xxs"].value}rem;
    padding-top: ${theme.spacing["spacing-2"].value}rem;
    padding-right: ${theme.spacing["spacing-4"].value}rem;
    padding-bottom: ${theme.spacing["spacing-2"].value}rem;
    padding-left: ${theme.spacing["spacing-4"].value}rem;
    background: ${
      $showGradientBackground
        ? getGradientBackground(theme, $percentage)
        : theme.Color.background.brand.subtlest["default-hover"].value
    };
    cursor: ${$isInInteractive ? "pointer" : "default"};
    height: 40px;
    transition: background-color 200ms ease-in-out;
      border: ${
        $isInInteractive ? theme.border_width["border-width-thin"].value : 0
      }rem solid transparent;
    
    &:hover {
      background: ${
        $showGradientBackground
          ? getGradientBackground(theme, $percentage)
          : $isInInteractive
          ? theme.Color.background.brand.subtlest["default-active"].value
          : theme.Color.background.brand.subtlest["default-hover"].value
      };
      border: ${
        $isInInteractive ? theme.border_width["border-width-thin"].value : 0
      }rem solid
      ${
        $isInInteractive
          ? theme.Color.border["ui-border-emphasize-brand"].value
          : "transparent"
      };
  }
`;
});
